import React, { Component, Fragment } from 'react'
import { action, computed, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import Button from 'material-ui/Button'
import withAppStore from 'decorators/withAppStore'
import styles from 'shared/styles/components/Datepicker'
import { Dialog, List, ListItem, ListItemText } from 'material-ui'
import { Typography } from 'material-ui'

@withStyles(styles)
@withAppStore
@observer
export default class OriginCountry extends Component {
  constructor(params) {
    super(params)
    this.state = {
      originCountry: this.props.originCountry,
    }
    this.handleListItemClick = this.handleListItemClick.bind(this)
    this.reload = this.reload.bind(this);
  }

  componentWillMount() {
    this.reload();
  }

  @computed
  get isOpened() {
    return this.appStore.isLoadCountries;
  }

  handleListItemClick = (item) => {
    this.appStore.originCountry = item['ab']
    this.setState({
      originCountry: item['ab'],
    })
    this.handleClose()
  }

  @observable isOpen = false

  @computed
  get label() {
    const { countries } = this.appStore;
    const { isMobile, direction } = this.props;
    const name = countries.find(x => x['ab'] === this.state.originCountry)
    const title = name !== undefined ?
      isMobile || name['ab'] !== 'ALL'
        ?
        name['short_name'] :
        name['ab'] !== 'ALL' && (direction !== '1' || direction !== '2')
          ?
          name['name']
          :
          direction === '2'
            ?
            name['name'] + 'происхождения'
            :
            name['name'] + 'назначения'
      :
      '';
    return isMobile ? (title.length < 15 ? title : title.substr(0, 10) + '...') : (title.length < 25 ? title : title.substr(0, 22) + '...');

  }

  render() {
    const { classes, isMobile } = this.props
    const { countries } = this.appStore
    return (
      <Fragment>
        <Button
          variant="flat"
          disableFocusRipple
          className={classes.button}
          onClick={this.handleOpen}
        >
          {isMobile && <Typography variant="caption">{this.label}</Typography>}
          {!isMobile && <Typography>{this.label}</Typography>}
        </Button>
        <Dialog onClose={this.handleClose} open={this.isOpen}>
          <List>
            {countries.map((item) => (
              <ListItem
                button
                onClick={() => this.handleListItemClick(item)}
                key={item['ab']}
              >
                <ListItemText primary={isMobile || item['ab'] !== 'ALL' ? item['short_name'] : item['name']} />
              </ListItem>
            ))}
          </List>
        </Dialog>
      </Fragment>

    )
  }

  @action.bound
  handleOpen() {
    this.isOpen = true
  }

  @action.bound
  handleClose() {
    this.isOpen = false
  }

  async reload() {
    const { originCountry } = this.props;
    if (!this.isOpened) {
      await this.appStore.countryStore.reload();
    }
    this.setState({
      originCountry: originCountry,
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OriginCountry.js